export default "__VITE_ASSET__zGaKTAfS__"